module.exports = __webpack_public_path__ + "img/undraw_building_websites_i78t.a8904c12.svg";